console.log("configurator js loaded");

document.addEventListener("DOMContentLoaded", function() {
    // Get the input field with class "vorname"
    var vornameField = document.querySelector(".vorname");
    // Add change event listener to the input field
    vornameField.addEventListener("keyup", function() {
        // Get the value of the input field
        var vornameValue = vornameField.value;
        // Do something with the input field value (e.g., log it to the console)
        console.log("Input field value:", vornameValue);
      var nachnameField = document.querySelector(".nachname");
      var nachnameValue = nachnameField.value;
      var voremailField = document.querySelector(".voremail");
      var voremailValue = voremailField.value;
      var datumField = document.querySelector(".datum");
      var datumValue = datumField.value;
      var personenanzahlField = document.querySelector(".personenanzahl");
      var personenanzahlValue = personenanzahlField.value;
      if(vornameValue != "" && nachnameValue != "" && voremailValue != "" && datumValue != "" && personenanzahlValue != ""){
        var checkboxes = document.querySelectorAll(".raumiette-checkbox");
        checkboxes.forEach(function(checkbox) {
          checkbox.removeAttribute("disabled");
        });
      }
    });

    // Get the input field with class "vorname"
    var nachnameField = document.querySelector(".nachname");
    // Add change event listener to the input field
    nachnameField.addEventListener("keyup", function() {
        // Get the value of the input field
        var nachnameValue = nachnameField.value;
        // Do something with the input field value (e.g., log it to the console)
        console.log("Input field value:", nachnameValue);
        var vornameField = document.querySelector(".vorname");
        var vornameValue = vornameField.value;        
        var voremailField = document.querySelector(".voremail");
        var voremailValue = voremailField.value;
        var datumField = document.querySelector(".datum");
        var datumValue = datumField.value;
        var personenanzahlField = document.querySelector(".personenanzahl");
        var personenanzahlValue = personenanzahlField.value;
        if(vornameValue != "" && nachnameValue != "" && voremailValue != "" && datumValue != "" && personenanzahlValue != ""){
          var checkboxes = document.querySelectorAll(".raumiette-checkbox");
          checkboxes.forEach(function(checkbox) {
            checkbox.removeAttribute("disabled");
          });
        }
    });

    // Get the input field with class "vorname"
    var voremailField = document.querySelector(".voremail");
    // Add change event listener to the input field
    voremailField.addEventListener("keyup", function() {
        // Get the value of the input field
        var voremailValue = voremailField.value;
        // Do something with the input field value (e.g., log it to the console)
        console.log("Input field value:", voremailValue);
        var vornameField = document.querySelector(".vorname");
        var vornameValue = vornameField.value;
        var nachnameField = document.querySelector(".nachname");
        var nachnameValue = nachnameField.value;        
        var datumField = document.querySelector(".datum");
        var datumValue = datumField.value;
        var personenanzahlField = document.querySelector(".personenanzahl");
        var personenanzahlValue = personenanzahlField.value;
        if(vornameValue != "" && nachnameValue != "" && voremailValue != "" && datumValue != "" && personenanzahlValue != ""){
          var checkboxes = document.querySelectorAll(".raumiette-checkbox");
          checkboxes.forEach(function(checkbox) {
            checkbox.removeAttribute("disabled");
          });
        }
    });

    // Get the input field with class "vorname"
    var datumField = document.querySelector(".datum");
    // Add change event listener to the input field
    datumField.addEventListener("keyup", function() {
        // Get the value of the input field
        var datumValue = datumField.value;
        // Do something with the input field value (e.g., log it to the console)
        console.log("Input field value:", datumValue);
        var vornameField = document.querySelector(".vorname");
        var vornameValue = vornameField.value;
        var nachnameField = document.querySelector(".nachname");
        var nachnameValue = nachnameField.value;
        var voremailField = document.querySelector(".voremail");
        var voremailValue = voremailField.value;        
        var personenanzahlField = document.querySelector(".personenanzahl");
        var personenanzahlValue = personenanzahlField.value;
        if(vornameValue != "" && nachnameValue != "" && voremailValue != "" && datumValue != "" && personenanzahlValue != ""){
          var checkboxes = document.querySelectorAll(".raumiette-checkbox");
          checkboxes.forEach(function(checkbox) {
            checkbox.removeAttribute("disabled");
          });
        }
    });

    // Get the input field with class "vorname"
    var personenanzahlField = document.querySelector(".personenanzahl");
    // Add change event listener to the input field
    personenanzahlField.addEventListener("keyup", function() {
        // Get the value of the input field
        var personenanzahlValue = personenanzahlField.value;
        // Do something with the input field value (e.g., log it to the console)
        console.log("Input field value:", personenanzahlValue);
        var vornameField = document.querySelector(".vorname");
        var vornameValue = vornameField.value;
        var nachnameField = document.querySelector(".nachname");
        var nachnameValue = nachnameField.value;
        var voremailField = document.querySelector(".voremail");
        var voremailValue = voremailField.value;
        var datumField = document.querySelector(".datum");
        var datumValue = datumField.value;        
        if(vornameValue != "" && nachnameValue != "" && voremailValue != "" && datumValue != "" && personenanzahlValue != ""){
          var checkboxes = document.querySelectorAll(".raumiette-checkbox");
          checkboxes.forEach(function(checkbox) {
            checkbox.removeAttribute("disabled");
          });
        }
    });

    var checkboxes = document.querySelectorAll('.raumiette-checkbox');
    // Add change event listener to each checkbox
    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        var numberInput = this.parentElement.querySelector('.recipe-quantity');
        if (this.checked) {
          if(numberInput){
            numberInput.removeAttribute('disabled');
          }
        }
      });
    });
  
    // Get the submit button
    var submitButton = document.querySelector(".submit-raummiette");
    // Add click event listener to the submit button
    submitButton.addEventListener("click", function() {
        // Get the value of the input field with class "vorname"
        var vorname = document.querySelector(".vorname").value;
        console.log("Input field value:", vorname);
        var nachnameField = document.querySelector(".nachname");
        var nachname = nachnameField.value;
        var voremailField = document.querySelector(".voremail");
        var voremail = voremailField.value;
        var datumField = document.querySelector(".datum");
        var datum = datumField.value;
        var personenanzahlField = document.querySelector(".personenanzahl");
        var personenanzahl = personenanzahlField.value;
        var telephonField = document.querySelector(".telephon");
        var telephon = telephonField.value;
        var checkboxes = document.querySelectorAll('.raumiette-checkbox:checked');
        var selecteditems = [];
        var total_price = 0;
        checkboxes.forEach(function(checkbox) {
          var item_quantity = checkbox.parentElement.querySelector('.recipe-quantity').value;
          var item_name = checkbox.parentElement.querySelector('.rh__title').textContent.trim();
          var item_price_text = checkbox.parentElement.querySelector('.rh__priceBtn').textContent.trim().replace('€', '');
          // var priceArray = price.split(' ');
          console.log(item_quantity);
          console.log(item_name);
          console.log(item_price_text);
          // console.log(priceArray);
          // Regular expression to match numbers with optional commas
          const regex = /(\d+,\d+)/;
          // Extract the number portion using regex
          const match = item_price_text.match(regex);
          if (match) {
              // Replace comma with dot and convert to float
              var item_price = parseFloat(match[0].replace(',', '.'));
              console.log(item_price);
              var new_item_price = item_price * item_quantity;
              console.log(new_item_price);
              total_price = parseFloat(total_price) + parseFloat(new_item_price);
              item_price = "EUR " + item_price.toFixed(2).replace('.', ',');
              new_item_price = "EUR " + new_item_price.toFixed(2).replace('.', ',');
              selecteditems.push({item_name:item_name, item_quantity:item_quantity, item_price:item_price, new_item_price:new_item_price});
          } else {
              console.log('No number found');
          }
        });
        console.log(selecteditems);
        console.log(total_price);
        total_price = "EUR " + total_price.toFixed(2).replace('.', ',');
        var mydata = {
          vorname: vorname,
          nachname: nachname,
          voremail: voremail,
          datum: datum,
          personenanzahl: personenanzahl,
          telephon: telephon,
          items: selecteditems,
          total_price: total_price
        };
        console.log(mydata);
        // var create_pdf_url = '';
        $.ajax({
          type: 'POST',
          url: 'https://bdntf-app.com/generate-pdf/pdf/html_to_pdf.php',
          data: mydata,
          datatype: 'json',
          success: function (data) {
            console.log(data);
            // window.open('https://bdntf-app.com/generate-pdf/pdf/' + data, '_blank');
            var pdfUrl = 'https://bdntf-app.com/generate-pdf/pdf/'+data;
            var filename = pdfUrl.substring(pdfUrl.lastIndexOf('/') + 1);
            $.ajax({
              url: pdfUrl,
              type: 'GET',
              xhrFields: {
                  responseType: 'blob' // Set the response type to blob
              },
              success: function(blob) {
                  // Create a downloadable link for the PDF file
                  var link = document.createElement('a');
                  link.href = window.URL.createObjectURL(blob);
                  link.download = filename; // Use the extracted filename for download
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  setTimeout(function () {
                    window.location.reload();
                  }, 2000);
              },
              error: function(xhr, status, error) {
                  console.error('Failed to download PDF:', error);
              }
            });
          },
          error: function (data) {
            $('.loader').hide();
            console.log("error enters");
            console.log(data);
          }
        });
    });
});